export default "<m-cube\n    color=\"pink\"\n    y=\"2\"\n    rx=\"45\"\n    ry=\"45\"\n    rz=\"45\"\n></m-cube>\n";